import {DeliveryMethod} from 'app/blocks/model/delivery-method.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IDeliveryMethod} from 'app/blocks/model/delivery-method.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class DeliveryMethodService extends EntityCrudService<IDeliveryMethod> {
    constructor(http: HttpClient) {
        super(http, Resource.DELIVERY_METHODS, (obj?) => new DeliveryMethod(obj));
    }
}
